/* global Vimeo */
var Acr = Acr || {};

Acr.VimeoPlayerManager = (function () {
  function vimeoPlayerObject(sourceId, playerContainer, autoplay, background, loop, muted) {
    var player = this;

    var vimeoOptions = {
      id: sourceId,
      autoplay: autoplay,
      background: background,
      controls: false,
      loop: loop,
      responsive: true,
      muted: muted,
    };

    player.playerObject = new Vimeo.Player(playerContainer, vimeoOptions);

    player.play = function () {
      if (player.playerObject.play) {
        player.playerObject.play();
      }
    };

    player.pause = function () {
      if (player.playerObject.pause) {
        player.playerObject.pause();
      }
    };
  }

  return {
    vimeoPlayerObject: vimeoPlayerObject,
  };
}());
